import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { 
    EarnedPointsQueryQuery, 
    EarnedPointsQueryQueryVariables
} from "../../../schemaTypes";


export const earnedPointsQuery = gql`
  query EarnedPointsQuery {
    earnedPoints {
      errors {
        path
        message
      }
      message
      totalPoints
    }
  }
`;

export const useEarnedPoints = () => {
  const { data, loading, error, refetch } = useQuery<
    EarnedPointsQueryQuery,
    EarnedPointsQueryQueryVariables
  >(earnedPointsQuery, {
    fetchPolicy: "network-only",
  });

  return {
    data: data?.earnedPoints || null,
    loading,
    error,
    refetch,
  };
};